import React from "react"
import HomeLayout from "../layout/homeLayout"
import AllCategories from "../templates/allCategories"
import SEO from "../components/seo"

export default function Home() {
  return (
    <HomeLayout>
      <SEO title="Home All HTML 5 Game Categories | mGamer Free online HTML 5 games" />

      <AllCategories />
      {/* <FeaturedGameCategories /> */}
      {/* <div>
        <a href="/gme_cnt2/game/index.html">Play Game now</a>
        <a href="/love.html">Love now</a>
      </div> */}
    </HomeLayout>
  )
}
